import React from 'react';
import { hot } from 'react-hot-loader/root';
import { Route } from 'react-router-dom';
import useAuth from 'src/hooks/useAuth';
import { PublicLayout } from '../Layout';

const PublicRoute: Route = ({ component: Component, ...rest }) => {
  const { user } = useAuth();
  return (
    <PublicLayout authenticated={user ? true : false}>
      <Route component={Component} {...rest} />
    </PublicLayout>
  );
};

export default hot(PublicRoute);
